export default __webpack_public_path__ + "static/media/05.6b3df796.jpeg";